import store from '@/store';
import BADGES_COLOR_MAP from '@/data/badges-color-map';
import WebhookModal from '@/modules/webhooks/webhook-modal';
import auth from '@/common/auth/auth';

export default function createColumns(testWebhook) {
    return {
        store,
        version: 6,
        defaultColumns: [
            {
                name: 'id',
                style: {truncate: true},
                type: 'link',
                to: ({fields}) => ({
                    name: 'update-webhook',
                    params: {id: fields.id},
                }),
                predicate: auth.$pages['update-webhook'].isAllowed,
                predicateOverride: {
                    type: 'text',
                },
                sticky: true,
            },
            {
                name: 'method',
                type: 'badge',
                map: BADGES_COLOR_MAP.method,
            },
            {
                name: 'url',
            },
            {
                name: 'status',
                type: 'badge',
                map: BADGES_COLOR_MAP.status,
            },
            {
                name: 'eventsFilter',
                type: 'component',
                component: WebhookModal,
                propsData: {name: 'eventsFilter', limit: 2},
            },
            {
                name: 'headers',
                type: 'component',
                component: WebhookModal,
                propsData: {name: 'headers', limit: 2},
            },
            {
                name: 'createdTime',
                header: 'Creation Time',
                type: 'datetime',
            },
            {
                name: 'updatedTime',
                header: 'Last Update Time',
                type: 'datetime',
            },
        ],
        otherColumns: [
            {
                name: 'credentialHash',
                style: {truncate: true},
            },
        ],
        lockedColumns: [
            {
                header: false,
                type: 'button',
                style: {
                    label: 'test webhook',
                },
                click: ({rowData, evt}) => {
                    testWebhook(rowData, evt.target);
                },
            },
        ],
    };
}
